import { Subject } from 'rxjs';
import { flog } from '@zambezi/caballo-vivo';
export var openTransientModal$ = new Subject().pipe(flog('Open simple modal'));
export var closeModal$ = new Subject().pipe(flog('Close modal'));